// script.js
// すべての .fadein 要素を取得
const elementsToAnimate = document.querySelectorAll('.fadein');

// 関数を作成して、要素が画面内に入ったときにアニメーションを追加する
function checkScroll() {
    const windowHeight = window.innerHeight;

    // すべての要素に対してループ処理を行う
    elementsToAnimate.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;

        if (elementTop < windowHeight * 0.75) {
            element.style.opacity = '1';
            element.style.transform = 'translateY(0)';
        }
    });
}

// 初回のチェック
checkScroll();

// スクロールイベントを監視して要素が画面内に入ったかどうかを確認
window.addEventListener('scroll', checkScroll);

window.onascroll = scrollFunction;

function scrollFunction() {
  document.getElementById("scrollButton").style.display = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) ? "block" : "none";
}

function scrollToTop() {
  var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
  var scrollAnimation = requestAnimationFrame(step);

  function step() {
    currentPosition -= Math.ceil(currentPosition / 20);
    document.documentElement.scrollTop = document.body.scrollTop = currentPosition;
    if (currentPosition > 0) {
      scrollAnimation = requestAnimationFrame(step);
    }
  }
}

// すべての画像コンテナを取得
const imageContainers = document.querySelectorAll('.photo-animation');

// Intersection Observerの設定（すべての画像コンテナに対して実行）
imageContainers.forEach((imageContainer) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // 要素が画面内に入ったらクリップパスを変更して徐々に表示
                imageContainer.style.clipPath = 'inset(0)';
                // Intersection Observerを一度だけ使用するため、観察を停止
                observer.unobserve(entry.target);
            }
        });
    });
    
    // 画像コンテナを観察対象として追加
    observer.observe(imageContainer);
});